<!-- 
Contents of the HISTORY tab of the provider page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="arrivedFromListing"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      user-guide-topic="listing-providers"
      user-guide-section="history"
      module="providers"
      nav-url="/providers/:id/history"
    />
    <tabs :provider-id="providerId" :incomplete-contacts="incompleteContacts">
      <our-search-button 
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search provider history"
        flat
        show-all
        @changed="$refs.history.refresh()"
      />
      <our-saved-searches-menu
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="systemLogs" 
        color="primary"
        flat dense
        @selected="$refs.history.refresh()"
      />
      <system-log-listing
        ref="history"
        :endpoint="`/api/providers/${providerId}/history`" 
        :export-endpoint="`/api/exports/providers/${providerId}/history`"
        :export-validate-endpoint="`/api/exports/validate/providers/${providerId}/history`"
        embedded 
      />
    </tabs>
  </div>
</template>

<script>
import providerMixins from "./mixins";
import Tabs from "./Tabs.vue";
import SystemLogListing from "@/components/system-logs/SystemLogListing.vue";
import * as mutation from "@/store/system-logs/mutation-types";
import { getSearchFilters } from "@/store/system-logs/helpers";

export default {
  name: "ProviderSummary",
  components: { SystemLogListing, Tabs },
  mixins: [providerMixins],
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA
    };
  },
  computed: {
    searchFilters() {
      return getSearchFilters("ProviderAction");
    },
    criteria() {
      return this.$store.state.systemLogs.listing.criteria;
    }
  }
};
</script>
